<template>
    <div class="interests">
        <div class="interests__header" @click="onChangeExpand">
            <IconStar />
            <h2 class="interests__title">Мои интересы</h2>
            <IconArrow2 v-if="isShowExpandButton" :is-expanded="isExpanded" />
        </div>
        <div v-if="isExpanded">
            <div class="interests__group" v-if="userCourseAreas.length > 0">
                <h3 class="interests__group-title">Направления</h3>
                <div class="interests__list">
                    <div
                        class="interests__list-item interests__list-item--course-area"
                        v-for="courseArea in userCourseAreas"
                        :key="courseArea.id"
                    >
                        {{ courseArea.name }}
                    </div>
                </div>
            </div>
            <div class="interests__group" v-if="userCompetencies.length > 0">
                <h3 class="interests__group-title">Компетенции</h3>
                <div class="interests__list">
                    <div
                        class="interests__list-item interests__list-item--competency"
                        v-for="competency in userCompetencies"
                        :key="competency.id"
                    >
                        {{ competency.name }}
                    </div>
                </div>
            </div>
        </div>
        <button class="interests__button button" @click="openModal" v-if="isShowButton">
            {{ textButton }}
        </button>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import IconStar from '@/views/track/icons/IconStar.vue';
import IconArrow2 from '@/views/track/icons/IconArrow2.vue';
import { securityService } from '@/tools/sequrity_service';

export default {
    name: 'MyInterests',
    components: {
        IconStar,
        IconArrow2,
    },

    data() {
        return {
            isExpanded: true,
        };
    },

    computed: {
        ...mapGetters('track', ['myInterests', 'userCompetencies', 'userCourseAreas']),
        ...mapGetters('auth', ['isAuthorized']),
        ...mapGetters(['isMobile']),

        textButton() {
            if (this.isAuthorized) {
                return 'Уточнить интересы';
            } else if (this.userCompetencies.length > 0 || this.userCourseAreas.length > 0) {
                return 'Сохранить подборку';
            } else {
                return 'Уточнить интересы';
            }
        },
        isShowButton() {
            if (this.isAuthorized || this.userCompetencies.length > 0 || this.userCourseAreas.length > 0) {
                return true;
            }

            if (!this.isAuthorized && this.userCompetencies.length === 0 && this.userCourseAreas.length === 0) {
                return true;
            }

            return false;
        },

        isShowExpandButton() {
            return this.isMobile && (this.userCompetencies.length > 0 || this.userCourseAreas.length > 0);
        },
    },

    methods: {
        ...mapActions('track', [
            'addUserCompetence',
            'addUserCourseArea',
            'fetchMyInterests',
            'deleteUserCompetence',
            'deleteUserCourseArea',
            'fetchMyRecommendations',
            'openDialogSelectInterests',
        ]),
        openModal() {
            if (this.isAuthorized) {
                this.openDialogSelectInterests();
            } else {
                if (this.userCompetencies.length > 0 || this.userCourseAreas.length > 0) {
                    securityService.signIn();
                }

                if (this.userCompetencies.length === 0 && this.userCourseAreas.length === 0) {
                    this.openDialogSelectInterests();
                }
            }
        },

        onChangeExpand() {
            if (this.isMobile) {
                this.isExpanded = !this.isExpanded;
            }
        },
    },

    beforeMount() {
        if (this.isMobile) {
            this.isExpanded = false;
        }
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables';

.interests {
    background-color: #fff;
    border-radius: urem(12);
    padding: 0 urem(20);
    font-family: $font-montserrat;

    padding-bottom: urem(20);

    @include on-desktop {
        padding: 0;
        padding-bottom: urem(40);
        width: urem(432);
        box-shadow: 0 urem(2) urem(16) urem(0) rgba(70, 99, 171, 0.16);
        border-radius: urem(16);
    }

    * {
        font-family: inherit;
    }

    &__header {
        padding-top: urem(6);
        display: flex;
        align-items: center;
        gap: urem(10);
        margin-bottom: urem(20);
        border-radius: urem(8);

        @include on-desktop {
            background-color: rgba(231, 241, 250, 1);
            height: urem(80);
            border-radius: 0;
            border-top-left-radius: urem(16);
            border-top-right-radius: urem(16);
            padding: 0 urem(24);
            margin: 0;
            margin-bottom: urem(40);
        }

        :deep(svg) {
            width: urem(32);
            height: urem(32);

            @include on-desktop {
                width: urem(44);
                height: urem(44);
            }
        }

        @include on-desktop {
            :deep(svg path) {
                transform-box: fill-box;
                transform-origin: center center;
                transform: scale(0.75);
            }
        }
    }

    &__title {
        font-size: urem(16);
        font-weight: 600;
        margin: 0;

        @include on-desktop {
            font-size: urem(20);
        }
    }

    &__tags {
        display: flex;
        flex-wrap: wrap;
        gap: urem(10);

        @include on-desktop {
            gap: urem(16);
            padding: urem(40);
            padding-bottom: 0;
            justify-content: center;
            margin-bottom: urem(-8);
        }
    }

    &__button {
        margin-top: urem(24);
        width: 100%;
        font-size: urem(14);
        font-weight: 600;
        background-color: rgba(70, 99, 171, 1);
        line-height: urem(20);
        color: white;
        border: none;
        border-radius: urem(10);
        padding: urem(11) urem(24);
        cursor: pointer;

        @include on-desktop {
            padding: urem(14) urem(32);
            width: fit-content;
            min-width: 0;
            margin: 0;
            margin-left: urem(24);
            margin-top: urem(12);
            margin-right: auto;
            transition: background 0.3s ease;

            &:hover {
                background: rgba(82, 112, 184, 1);
            }
        }
    }

    :deep(.interests__modal) {
        padding: 0;

        .dialog {
            max-height: 100vh;
            height: 100%;
            @include on-desktop {
                height: 100%;
                max-height: 80%;
            }
        }
    }

    &__group {
        margin-bottom: urem(16);

        @include on-desktop {
            margin-bottom: 0;
            padding: urem(24);
            padding-top: 0;
        }
    }

    &__list {
        display: flex;
        flex-wrap: wrap;
        gap: urem(10);

        @include on-desktop {
            gap: urem(16);
        }
    }

    &__group-title {
        font-size: urem(14);
        line-height: urem(20);
        font-weight: 600;
        margin: 0;
        margin-bottom: urem(8);

        @include on-desktop {
            font-size: urem(18);
            line-height: urem(18);
            margin-bottom: urem(20);
        }
    }

    &__list-item {
        display: flex;
        align-items: center;
        gap: urem(8);
        padding: urem(4) urem(10);
        border-radius: urem(10);
        line-height: urem(20);
        font-size: urem(11);
        font-weight: 500;
        color: rgba(70, 99, 171, 1);
        background: none;

        @include on-desktop {
            font-size: urem(14);
            padding: urem(8) urem(12);
        }

        &--course-area {
            background: rgba(236, 239, 247, 1);
            color: rgba(70, 99, 171, 1);
            .interests__remove {
                stroke: rgba(70, 99, 171, 1);
            }
        }

        &--competency {
            background: rgba(240, 239, 245, 1);
            color: rgba(105, 96, 159, 1);
            .interests__remove {
                stroke: rgba(105, 96, 159, 1);
            }
        }
    }

    &__remove {
        display: block;
        height: urem(20);
        width: urem(21);
        border: none;
        background: none;
        padding: 0;
        cursor: pointer;

        @include on-desktop {
            height: urem(24);
            width: urem(24);
        }

        :deep(svg) {
            width: urem(20);
            height: urem(20);
            display: block;
        }
    }
}
</style>
